<template>
    <div class="com-right-content text-white">
        <div >
            <BlockBox title="品类回收占比" enTitle="Category recovery ratio" height="285">
                <template #content>
                    <div class="custDate">
                        <el-row :gutter="10">
                            <el-col :span="8">
                                <el-date-picker value-format="yyyy-MM-dd" :clearable="false" v-model="plDate"
                                    @change="dataChange($event,'plDate')" size="mini" type="date" placeholder="选择日期">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="8">
                                <el-date-picker value-format="yyyy-MM" :clearable="false" v-model="plMonth"
                                    @change="dataChange($event,'plMonth')" type="month" size="mini" placeholder="选择月">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="8">
                                <el-date-picker value-format="yyyy" :clearable="false" v-model="plYear"
                                    @change="dataChange($event,'plYear')" type="year" size="mini" placeholder="选择年">
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div id="chartFwqk" style="height:205px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
       
        <div class="margin-top-15">
            <BlockBox title="今日减碳总量(kg)" enTitle="Total carbon reduction for today" height="176">
                <template #content>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div class="text-center text-green bigNum" style="height:130px;" v-if="item.dayWeight">
                            <!-- {{formatter(item.yesterdayJtl)}} -->{{item.dayWeight?item.dayWeight:'0'}}
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
            <BlockBox title="累积减碳总量(kg)" enTitle="Cumulative Carbon Reduction" height="176">
                <template #content>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div class="text-center  bigNum" style="height:130px;color:#ff94a3;" v-if="item.allWeight">
                            {{item.allWeight?item.allWeight:'0'}}
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
        	<BlockBox title="即时下单" enTitle="lmmediate order" height="306">
        		<template #content>
        			<div style="padding:0 15px;box-sizing: border-box">
        				<div class="shtjBox margin-top-10" >
        					<div class="swiper" >
        						<div class="swiper-wrapper">
        							<div class="swiper-slide" v-for="(obj,index) in dkList" :key="index">
        								<div class="shtjItem base-font-14">
        									<el-image class="notcieIcon" :src="notice"></el-image>用户<span
        										class="text-blue">{{obj.upstream_customers_name}}</span>于{{obj.create_time}}<span
        										class="text-green">下单成功</span>
        								</div>
        							</div>
        						</div>
        					</div>
        				</div>
        			</div>
        		</template>
        	</BlockBox>
        </div>
        <!-- <div class="margin-top-15">
			<BlockBox title="总出库量(kg)" enTitle="Total carbon reduction yesterday " height="176">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div class="text-center text-green bigNum" style="height:130px;" v-if="item.yesterdayJtl">
							{{item.yesterdayJtl}}
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="库存量(kg)" enTitle="Cumulative Carbon Reduction" height="176">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div class="text-center  bigNum" style="height:130px;color:#ff94a3;" v-if="item.allJtl">
							{{item.allJtl}}
						</div>
					</div>
				</template>
			</BlockBox>
		</div> -->
      

    </div>
</template>

<script>
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox'
    import notice from '@/assets/img/notice.png'
    import 'swiper/swiper-bundle.min.css'
    import Swiper from 'swiper/swiper-bundle';
    import {
        ptRightData,
        ptStatisticsCategory
    } from "@/api/api";
    export default {
        name: "cityGreenLand",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
                notice,
                item: {},
                dkList: [],
                colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],
                timerRight: null,
                cktjList:[],
                plList: [],
                plDate: "",
                plMonth: "",
                plYear: "",
               
                swiperShow:false
            }
        },
        mounted() {
            this.changeData()
            this.getptStatisticsCategory()
            // this.getptStatisticsOutSite()
            this.timerRight = setTimeout(() => {
                this.changeData()
                this.getptStatisticsCategory()
                // this.getptStatisticsOutSite()
            }, 60000);
           

        },
        beforeDestroy() {
            clearTimeout(this.timerRight);
        },
        methods: {
            changeData() {
                let _self = this
                 _self.getCurrentMonth()
                ptRightData().then(res => {
                    _self.item = res.data;
                    _self.dkList = res.data.memberList;
                    _self.swiperShow=true
                    _self.$nextTick(()=>{
                    	_self.initSwiper()
                    })
                });
            },
            getCurrentMonth() {
                  const now = new Date();
                  // const month = now.getMonth() + 1; // 月份是从0开始的，所以需要+1
                  const year =now.getFullYear()
                  this.plYear = year+''
                  // this.ckMonth = month+''
            },
          
            getptStatisticsCategory() {
                let _self = this
                ptStatisticsCategory({
                    year: _self.plYear,
                    month: _self.plMonth,
                    day: _self.plDate
                }).then(res => {
                    _self.plList = res.data.list
                    _self.$nextTick(function() {
                        _self.drawFwqk();
                    });
                })
            },


            
            drawFwqk() {
                this.chart = this.$echarts.init(document.getElementById("chartFwqk"));
                let data = this.plList
                if (this.plList && this.plList.length > 0) {
                    this.plList.forEach(item => {
                        data.push({
                            name: item.name,
                            value: item.weight
                        })
                    })
                }
                let option = {
                    color: ['#0086ff', '#00ff97', '#2500ff', '#ff2466'],
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: 'top',
                        left: 'left',
                        textStyle: {
                            color: '#ffffff' // 设置字体颜色为红色s
                        }
                    },
                    grid: {
                        left: '1%',
                        right: '3.5%',
                        bottom: '3%',
                        top: 20,
                        containLabel: true
                    },
                    series: [{
                        name: '回收占比',
                        type: 'pie',
                        radius: ['35%', '55%'],
                        center: ['50%', '58%'],
                        avoidLabelOverlap: false,
                        padAngle: 30,
                        itemStyle: {
                            borderRadius: 10
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,

                    }]
                };
                // echart图表自适应
                this.chart.setOption(option)
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            },


            formatter(number) {
                const numbers = number.toString().split('').reverse()
                const segs = []

                while (numbers.length) segs.push(numbers.splice(0, 3).join(''))

                return segs.join(',').split('').reverse().join('')
            },
            dataChange(e, name) {
                this[name] = e
                if (name === "plDate") {
                    this.plMonth = ''
                    this.plYear = ''
                }
                if (name === "plMonth") {
                    this.plDate = ''
                    this.plYear = ''
                }
                if (name === "plYear") {
                    this.plMonth = ''
                    this.plDate = ''
                }
                this.getptStatisticsCategory()

            },
            initSwiper() {
            	new Swiper('.swiper', {
            		autoplay: true, //可选选项，自动滑动
            		direction: 'vertical',
            		height: 200, //你的slide高度
            		slidesPerView: 4,
            	})
            }


        }
    }
</script>

<style lang="scss">
    // .baseItemBox {
    // 	min-height: 500px;
    // 	padding: 14px 15px 15px 15px;
    // 	box-sizing: border-box;
    
    // 	.shtjItem {
    // 		width: 100%;
    // 		height: 38px;
    // 		line-height: 38px;
    // 		border: 1px solid #155898;
    // 		line-height: 38px;
    // 		padding: 0 5px;
    // 		box-sizing: border-box;
    // 		cursor: pointer;
    // 	}
    
    // 	.shtjItem:hover {
    // 		background: #155898;
    // 	}
    
    // 	.shtjBox {
    // 		height: 200px;
    
    // 		& .swiper {
    // 			height: 200px;
    // 		}
    // 	}
    // }
    .com-right-content {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .shtjItem {
			width: 100%;
			height: 38px;
			line-height: 38px;
			border: 1px solid #155898;
			line-height: 38px;
			padding: 0 5px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.shtjItem:hover {
			background: #155898;
		}

		.shtjBox {
			height: 200px;

			& .swiper {
				height: 200px;
			}
		}


        .wzdjItem {
            width: 100%;
            height: 35px;
            line-height: 21px;
            padding: 11px 0;
            cursor: pointer;
        }

        .wzdjItem:hover {
            color: #006AF6;
        }

        .wzdjItem .leftNum {
            width: 21px;
            height: 21px;
            border-radius: 2px;
            background: #006AF6;
            line-height: 21px;
            text-align: center;
        }

        .wzdjItem .leftNum.one {
            background: -webkit-linear-gradient(top, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
        }

        .wzdjItem .leftNum.two {
            background: -webkit-linear-gradient(top, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
        }

        .shtjBox {
            height: 250px;

            & .swiper {
                height: 250px;
            }
        }
    }


    .hnzbLable {
        margin-top: 10px;
    }

    .hnzbLable .itemLable {
        line-height: 1;
        border: 1px solid;
        color: #2196f3;
        font-size: 12px;
        padding: 5px 7px;
        border-radius: 1px;
    }

    .hnzbLable .itemLable+.itemLable {
        margin-left: 7px;
    }

    .hnzbLable .itemLable.checked {
        background: #006AF6;
        color: #FFFFFF;
        border-color: #006AF6;
    }

    //调整区域****************
    .padding-top-10 {
        padding-top: 10px;
    }

    .videoBox {
        width: 100%;
        height: 205px;
        border-radius: 10rpx;
        overflow: hidden;

        iframe {
            width: 100%;
            height: 240px;
        }
    }

    .text-white {
        color: #FFFFFF;
    }

    .enTitle {
        padding-left: 3px;
        font-size: 13px;
        border-left: 2px solid #FFFFFF;
        margin-left: 7px;
        font-weight: lighter;
    }

    .base-titleBox-flex {
        padding-top: 9px;
        line-height: 1
    }

    .bigNum {
        font-weight: bold;
        line-height: 130px;
        font-size: 48px;
    }

    .text-green {
        color: #15ff15;
    }

    .midTitleBox {
        font-size: 15px;
        font-weight: bold;
        color: #FFFFFF;
        padding-left: 20px;
        box-sizing: border-box;
    }

    .base-font-16 {
        font-size: 16px;
    }

    .text-bold {
        font-weight: bold;
    }

    .custDate {
        padding: 5px 15px 10px 15px;
    }

    .custDate .el-date-editor.el-input,
    .custDate .el-date-editor.el-input__inner {
        width: 140px;

    }

    .el-input__inner {
        background: rgba(8, 69, 120, 0.2);
        border-color: #006AF6;
        color: #00a2d5;
    }

    .el-input__prefix,
    .el-input__suffix {
        color: #00a2d5;
    }
    .notcieIcon {
    	width: 16px;
    	height: 16px;
    	display: inline-block;
    	vertical-align: middle;
    	margin-right: 5px;
    }
</style>